import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { Injectable } from '@angular/core';
import { standardCommand } from '../../../core/model/command';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { CopyAccountPlanCommandHandler } from './copy-account-plan-command-handler.service';
import { accountPlanCommand } from './account-plan.command';

@Injectable()
export class AccountPlanCommandHandlerResolver extends CommandHandlerResolver {
  constructor(edit: EditCommandHandler, copy: CopyAccountPlanCommandHandler, deleteCommand: DeleteCommandHandler) {
    super();
    this.addHandler(standardCommand.edit, edit);
    this.addHandler(accountPlanCommand.copy, copy);
    this.addHandler(standardCommand.delete, deleteCommand);
  }
}
